import {
	Avatar,
} from '@mui/material'
import {
	memo,
} from 'react'

import type {
	IAvatarBaseProps,
} from './avatar-base.types'

export const AvatarBase = memo((props: IAvatarBaseProps) => {
	const {
		src,
		...others
	} = props

	const avatarURL = src ?? '/assets/images/stubs/stub-avatar.jpg'

	return (
		<Avatar src={avatarURL} {...others} />
	)
})
